<!-- contact-page.vue -->
<template>
  <Layout>
    <div class="bg-gray-50 py-12 md:py-24">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="text-center mb-12 md:mb-16">
          <h1 class="text-4xl sm:text-5xl font-extrabold text-[#00395a] tracking-tight">Get In Touch</h1>
          <p class="mt-4 text-lg sm:text-xl text-black max-w-2xl mx-auto">
            We'd love to hear from you! Whether you have a question, a suggestion, or just want to say hello, feel free to reach out.
          </p>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12 items-start">
          <!-- Contact Details Section -->
          <div class="bg-white p-6 sm:p-8">
            <h2 class="text-2xl sm:text-3xl font-bold text-[#00395a] mb-6">Contact Information</h2>
            
            <div class="space-y-6">
              <div>
                <h3 class="flex items-center text-lg font-semibold text-gray-800 mb-2">
                  <svg class="w-6 h-6 text-[#00395a] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z"></path><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 11a3 3 0 11-6 0 3 3 0 016 0z"></path></svg>
                  Our Address
                </h3>
                <p class="text-black leading-relaxed text-left">
                  Shree Ghoghari Lohana Mahajan<br>
                  Ground Floor, Lohana Bhuvan,<br>
                  Paliram Road, Andheri (West),<br>
                  Mumbai – 400 058, Maharashtra, India.
                </p>
              </div>

              <div>
                <h3 class="flex items-center text-lg font-semibold text-gray-800 mb-2">
                  <svg class="w-6 h-6 text-[#00395a] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.308 1.154a11.031 11.031 0 005.516 5.516l1.154-2.308a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z"></path></svg>
                  Phone
                </h3>
                <p class="text-black text-left">
                  <a href="tel:+919987240404" class="hover:text-[#00395a] transition-colors">Mobile: +91 99872 40404</a>
                </p>
              </div>

              <div>
                <h3 class="flex items-center text-lg font-semibold text-gray-800 mb-2">
                  <svg class="w-6 h-6 text-[#00395a] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z"></path></svg>
                  Email
                </h3>
                <p class="text-black text-left">
                  <a href="mailto:contact@sglm.in" class="hover:text-[#00395a] transition-colors">contact@sglm.in</a>, 
                  <a href="mailto:sandesh@sglm.in" class="hover:text-[#00395a] transition-colors">sandesh@sglm.in</a>
                </p>
              </div>

              <div>
                <h3 class="flex items-center text-lg font-semibold text-gray-800 mb-2">
                  <svg class="w-6 h-6 text-[#00395a] mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"></path></svg>
                  Office Timings
                </h3>
                <p class="text-black text-left">10:00 AM TO 6:00 PM</p>
                <p class="text-black text-left"><span class="font-medium">Weekly Holiday:</span> Thursday</p>
              </div>
            </div>
          </div>

          <!-- Map Section -->
          <div class="bg-white overflow-hidden h-96 md:h-full">
            <!-- Replace with your actual Google Maps embed code -->
            <!-- Go to Google Maps, find your location, click "Share", then "Embed a map", and copy the HTML -->
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.5300000000003!2d72.83000000000001!3d19.128000000000004!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMTnCsDA3JzQxLjAiTiA3MsKwNDknNDguMCJF!5e0!3m2!1sen!2sin!4v1620000000000!5m2!1sen!2sin" 
              width="100%" 
              height="100%" 
              style="border:0;" 
              allowfullscreen="" 
              loading="lazy"
              referrerpolicy="no-referrer-when-downgrade"
              title="Shree Ghoghari Lohana Mahajan Location">
            </iframe>
            <!-- 
              A more specific (but still placeholder) embed URL for "Lohana Bhuvan, Andheri West":
              https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3769.530120057991!2d72.83000061485216!3d19.12800098705827!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3be7b61a45ffffff%3A0x3f7018a75a0e7c8!2sLohana%20Mahajan%20Wadi!5e0!3m2!1sen!2sin!4v1670000000000!5m2!1sen!2sin
              You should generate your own from Google Maps for accuracy.
            -->
          </div>
        </div>

        <!-- Optional: Contact Form Section (Add later if needed) -->
        <!-- 
        <div class="mt-16 pt-12 border-t border-gray-200">
          <h2 class="text-3xl font-bold text-[#00395a] text-center mb-8">Send us a Message</h2>
          <form action="#" method="POST" class="max-w-xl mx-auto bg-white p-8 rounded-xl shadow-xl">
            </form>
        </div>
        -->
      </div>
    </div>

  </Layout>
</template>

<script>
import Layout from './../layouts/LayoutView.vue'

export default {
  data() {
    return {
      // page: {}, // This 'page' data property doesn't seem to be used.
    }
  },
  components: {
    Layout
  },
}
</script>
  